import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GuestsState } from './guests.state';

export const selectGuestsState = createFeatureSelector<GuestsState>('adminGuests');

export const selectAllGuests = createSelector(
  selectGuestsState,
  (state: GuestsState) => state.guests,
);

export const selectGuestsLoading = createSelector(
  selectGuestsState,
  (state: GuestsState) => state.loading,
);

export const selectGuestsError = createSelector(
  selectGuestsState,
  (state: GuestsState) => state.error,
);

export const selectGuestsPagination = createSelector(
  selectGuestsState,
  (state: GuestsState) => state.pagination,
);
